import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import AkButton from '@atlaskit/button/standard-button';
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { TEST_ID } from '@atlassian/mpac-app-listing';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import React, { useEffect, useState } from 'react';
import { ANALYTICS_OBJECT_TYPE_APP_LISTING, ANALYTICS_SUBJECT_ID_REQUEST_APP, AppRequestButtonViewed } from '../../analytics/Events';
import RequestAppModal from './RequestAppModal';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export const RequestAppButton = props => {
  const {
    enableAetherAppListingPage
  } = useStatsig();
  const buttonAppearance = enableAetherAppListingPage() ? 'primary' : 'warning';
  return /*#__PURE__*/_jsx(AkButton, {
    testId: TEST_ID.REQUEST_APP_BTN,
    appearance: buttonAppearance,
    onClick: props.onClick,
    children: props.label
  });
};
export default function RequestApp(props) {
  const [isDialogOpen, setDialogOpenFlag] = useState(props.isRequestDialogOpen);
  const fireAnalyticsEvent = useAnalyticsEvents();
  const ecosystemCloudAppId = props.ecosystemCloudAppId;
  useEffect(() => {
    fireAnalyticsEvent({
      attributes: _objectSpread({}, ecosystemCloudAppId && {
        isEcosystemCloudApp: true,
        ecosystemCloudAppId
      }),
      eventType: AppRequestButtonViewed,
      objectType: ANALYTICS_OBJECT_TYPE_APP_LISTING,
      objectId: props.appKey
    });
  }, []);
  const toggleDialog = () => {
    setDialogOpenFlag(!isDialogOpen);
  };
  const onRequestAppButtonClick = () => {
    handleAnalyticsEvent(ANALYTICS_SUBJECT_ID_REQUEST_APP);
    toggleDialog();
  };
  const handleAnalyticsEvent = actionSubjectId => fireAnalyticsEvent({
    attributes: _objectSpread({}, ecosystemCloudAppId && {
      isEcosystemCloudApp: true,
      ecosystemCloudAppId
    }),
    eventType: ButtonClickedEvent,
    actionSubjectId,
    objectType: ANALYTICS_OBJECT_TYPE_APP_LISTING,
    objectId: props.appKey
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(RequestAppButton, {
      onClick: onRequestAppButtonClick,
      label: props.appListingCTA
    }), isDialogOpen && /*#__PURE__*/_jsx(RequestAppModal, _objectSpread(_objectSpread({}, props), {}, {
      closeModal: toggleDialog
    }))]
  });
}